<!-- DB management component dedicated to the categories (for the issues)  -->

<template>
  <div>
    <v-layout
      align-center
      justify-space-between>
      <span class="headline">
        Categories
      </span>
      <v-btn
        color="green darken-2"
        class="ma-0"
        @click="add">
        New category
      </v-btn>
    </v-layout>

    <v-container>

      <template v-if="loading">
        <v-layout
          class="mt-5"
          justify-center>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>

      <template v-else-if="categories.length === 0">
        <v-layout
          class="mt-5"
          justify-center>
          <span class="title">No category.</span>
        </v-layout>
      </template>

      <template v-else>
        <v-progress-linear
          v-if="deleting"
          class="ma-0"
          color="grey"
          height="1"
          indeterminate/>
        <v-divider v-else/>
        <v-data-table
          v-if="categories.length > 0"
          :headers="headers"
          :items="categories"
          hide-actions>
          <template
            slot="items"
            slot-scope="props">
            <tr>
              <td>
                {{ props.item.name }}
              </td>
              <td>
                {{ props.item.description }}
              </td>
              <td class="justify-center layout px-0">
                <v-btn
                  icon
                  class="mx-0"
                  @click="edit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="mx-0"
                  @click="del(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>

    </v-container>

    <v-dialog
      v-model="dialog"
      max-width="50rem"
      persistent>
      <v-card>
        <v-card-text>
          <v-form v-model="valid">
            <v-container grid-list-sm>
              <v-layout>
                <v-flex>
                  <v-text-field
                    v-model="category.name"
                    :rules="[v => !!v || 'Name is required']"
                    label="Name"/>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-textarea
                    v-model="category.description"
                    rows="1"
                    auto-grow
                    label="Description"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="posting"
            flat
            @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            :disabled="posting || !valid"
            flat
            @click="save">
            <v-progress-circular
              v-if="posting"/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  data () {
    return {
      // Array containing all categories, populated in `created`
      categories: [],
      // Currently edited category
      category: {},
      // Default category
      defaultCategory: {
        name: "",
        description: ""
      },
      deleting: false,
      // Boolean to toggle a dialog to edit a category
      dialog: false,
      headers: [
        {
          text: "Name",
          value: "name",
          width: "30%"
        },
        {
          text: "Description",
          value: "description"
        },
        {
          text: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: "10%"
        }
      ],
      /*
       * Index of the currently edited category in the array `categories`
       * `index` is -1 when a new category is added or edition mode is off
       */
      index: -1,
      loading: false,
      posting: false,
      valid: false
    };
  },
  created () {
    this.getCategories();
  },
  methods: {
    add () {
      this.index = -1;
      this.category = Object.assign({}, this.defaultCategory);
      this.dialog = true;
    },
    edit (cat) {
      // Toggle the edition dialog for the received category
      this.index = this.categories.indexOf(cat);
      Object.assign(this.category, cat);
      this.dialog = true;
    },
    del (cat) {
      // Delete category received as argument
      if (confirm("Are you sure you want to delete this category?")) {
        this.deleting = true;
        this.$http.
          delete(`/api/categories/${cat.id}`).
          then(() => this.getCategories()).
          finally(() => this.deleting = false);
      }
    },
    getCategories () {
      // Get the categories
      this.loading = true;
      this.$http.
        get("/api/categories").
        then((r) => this.categories = Array.from(r.data)).
        finally(() => this.loading = false);
    },
    save () {
      if (this.index > -1) {
        // Existing category has been edited
        this.posting = true;
        this.$http.
          put(`/api/categories/${this.category.id}`, this.category).
          then(() => {
            this.getCategories();
            this.dialog = false;
          }).
          finally(() => this.posting = false);
      } else {
        // New category has been created
        this.posting = true;
        this.$http.
          post("/api/categories", this.category).
          then(() => {
            this.getCategories();
            this.dialog = false;
          }).
          finally(() => this.posting = false);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/Categories.vue